import { useCommunicationChannel } from "V2.0/HomePages/Assistants/CommunicationBinding/useCommunicationChannel";
import { TriggerNodeSettings } from "./TriggerNodeV2";
import { useEffect } from "react";

function SmsTriggerNodeSettings(props) {
  const { workspaceId } = props;
  const { communicationChannel, fetchCommunicationChannels } =
    useCommunicationChannel({ workspaceId });
  const { phoneNumbers } = communicationChannel;

  useEffect(() => {
    console.log({ props });
    if (workspaceId) {
      fetchCommunicationChannels();
    }
  }, [workspaceId]);

  return (
    <TriggerNodeSettings
      phoneNumbers={phoneNumbers}
      channelType="sms"
      {...props}
    />
  );
}

export default SmsTriggerNodeSettings;
